import type { ComponentType } from 'react';

import { AgreementsReadMoreModal } from '@/components/agreements/agreements-read-more-modal';
import { RecipientDetailsModal } from '@/components/loan-form/recipient-details-modal';
import { LoanActionCardModal } from '@/components/dashboard/components/loan-action-card/loan-action-card-modal';
import { LoanCancelModal } from '@/components/dashboard/components/loans-list/loan-cancel/loan-cancel-modal';
import { LiberisAdditionalAgreementsInfo } from '@/components/welcome/loan-application-possible/liberis/agreements-liberis/liberis-additional-agreements-info';
import { RepresentativeAddressDataForm } from '@/components/welcome/loan-application-possible/liberis/common/components/representative-address-data-form';
import { MultiproviderLiberisStageModalContent } from '@/components/select-offer/multiprovider/modals/multiprovider-liberis-stage-modal-content';
import { NoAvailableOffersModalContent } from '@/components/select-offer/multiprovider/modals/no-available-offers-modal-content';
import { PragmaFormModalContent } from '@/components/select-offer/multiprovider/modals/pragma-form-modal-content';
import { PromotionCodeErrorModalContent } from '@/components/promotion-code/promotion-code-error-modal-content';

import type { ModalStateKeys, ModalStateUnion } from './modal.store';
import { MODAL_STATE } from './modal.store';
import { ExampleModal } from './example-modal';

const MODAL_COMPONENTS: Record<ModalStateKeys, ComponentType> = {
  [MODAL_STATE.LOAN_RECIPIENT_DETAILS]: RecipientDetailsModal,
  [MODAL_STATE.LOAN_AGREEMENTS]: AgreementsReadMoreModal,
  [MODAL_STATE.EXAMPLE_MODAL]: ExampleModal,
  [MODAL_STATE.LOAN_ACTION_CARD_MODAL]: LoanActionCardModal,
  [MODAL_STATE.LOAN_CANCEL]: LoanCancelModal,
  [MODAL_STATE.REPRESENTATIVE_ADDRESS_DATA]: RepresentativeAddressDataForm,
  [MODAL_STATE.LIBERIS_AGREEMENTS_ADDITIONAL_INFO]: LiberisAdditionalAgreementsInfo,
  [MODAL_STATE.LIBERIS_MULTIPROVIDER_LOAN_STAGE]: MultiproviderLiberisStageModalContent,
  [MODAL_STATE.NO_AVAILABLE_OFFERS]: NoAvailableOffersModalContent,
  [MODAL_STATE.PRAGMA_FORM]: PragmaFormModalContent,
  [MODAL_STATE.PROMOTION_CODE_ERROR]: PromotionCodeErrorModalContent,
};

interface ModalContent {
  modalType: ModalStateUnion;
}
export function ModalContent({ modalType }: ModalContent) {
  const Content = MODAL_COMPONENTS[modalType];

  return <Content />;
}
